import { render, staticRenderFns } from "./SaveAndPublishButton.vue?vue&type=template&id=00cd80ea&scoped=true&"
import script from "./SaveAndPublishButton.vue?vue&type=script&lang=js&"
export * from "./SaveAndPublishButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cd80ea",
  null
  
)

export default component.exports